import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

/**
 * Interceptor para establecer los elementos básicos de las peticiones
 * https://stackoverflow.com/questions/34516651/set-base-url-for-angular-2-http-requests
 */
@Injectable()
export class BaseInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    /* Si la url incluye el flag '@', no añadirá la urlBase  */
    if (req.url.includes('@')) {
      req = req.clone({
        url: this.sanitizeFlag(req.url)
      });
    } else if (!/http:\/\/[\w.0-9]+(:[0-9]+)?\/[a-zA-Z0-9_-]+/.test(req.url)) {
      /* Si la url de la petición no tiene dominio, añade la URL base. */
      const url = environment.base.url;
      req = req.clone({
        url: url + req.url
      });
    }

    // Se añade la cabecera Content-Type
    req = req.clone({ headers: req.headers.set('Content-Type', 'application/json') });

    return next.handle(req);
  }

  sanitizeFlag(url) {
    return url.includes('@') ? url.replace('@', '') : url;
  }
}
